import { Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";


function CartInprogress() {
    const { t } = useTranslation();
    return (
        <>
            <Container sx={{ pt: 4 }}>
                <Typography sx={{ fontSize: '32px', fontWeight: 300, textAlign: 'center', pb: 2 }}>
                    {t("cart.paymentProcessing")}
                </Typography>
            </Container>

        </>
    );
}

export default CartInprogress;
